<template>
  <div class="app-container">
    <div class="index-tree-box">
      <div class="left-box">
        <div class="left-title">
          <span style="cursor: pointer;" @click="allData">所有分类</span>
          <el-button type="text" @click="createTree" icon="el-icon-circle-plus-outline"></el-button>
        </div>
        <div class="left-main">
          <goods-tree ref="goodsTree" @on-select="onSelect"></goods-tree>
        </div>
      </div>
      <div class="right-box">
        <list ref="list">
          <template slot="toolbar-right" v-if="$permission.canWrite()">
        <el-button size="mini" type="success" plain @click="onImportClass" icon="el-icon-plus">分类导入</el-button>
            <el-button
              :disabled="data.IdChain==''"
              size="mini"
              type="primary"
              @click="create"
              icon="el-icon-plus"
            >添加</el-button>
            <el-button size="mini" type="danger" @click="delRows">删除</el-button>
        <el-button size="mini" type="success" plain @click="onExport" v-if="$permission.canExport()">导出</el-button>
        <el-button size="mini" type="success" plain @click="onImport" icon="el-icon-plus">导入</el-button>
          </template>
          <template slot="column" v-if="$permission.canWrite()">
            <el-table-column label="操作" fixed="right" align="center" width="80">
              <template slot-scope="{row}">
                <el-button type="text" @click="editById(row.GoodsId)">编辑</el-button>
              </template>
            </el-table-column>
          </template>
        </list>
      </div>
    </div>
    <edit-dialog ref="editDialog" @close-saved="reload"></edit-dialog>
    <import-dialog ref="importDialog" @upload-success="reload" />
    <import-dialog-class ref="importDialogClass" @upload-success="reload" />
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import list from "@/components/basicinfo/goods/archives/list";
import editDialog from "@/components/basicinfo/goods/archives/editDialog";
import goodsTree from "@/components/basicinfo/goods/archives/goodsTree/tree";
import importDialog from "@/components/basicinfo/goods/archives/importDialog";
import importDialogClass from '@/components/basicinfo/goods/archives/importDialogClass.vue';

export default {
  name: "archives",
  mixins: [curdMixins],
  components: {
    list,
    editDialog,
    goodsTree,
    importDialog,
    importDialogClass
  },
  data() {
    return {
      data: {
        IdChain: "",
        ClassName: "",
        ClassId: "",
      },
    };
  },
  mounted() {
    this.$refs.goodsTree.getData();
  },
  methods: {
    onImportClass() {
      this.$refs.importDialogClass.open();
    },
    onImport() {
      this.$refs.importDialog.open();
    },
    onExport() {
      this.$confirm("是否导出数据？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$refs.list.onExport();
        })
        .catch(() => {});
    },
    allData() {
      this.resetSelect();
      this.$refs.list.getData({ IdChain: "" });
      // 
    },
    resetSelect() {
      this.$refs.goodsTree.resetSelect();
      this.data.IdChain = "";
      this.data.ClassName = "";
      this.data.ClassId = "";
    },
    onSelect(data) {
      
      if (this.data.IdChain != data.IdChain) {
        this.data.IdChain = data.IdChain;
        this.data.ClassName = data.ClassName;
        this.data.ClassId = data.ClassId;
        this.$refs.list.getData({ IdChain: data.IdChain });
      }
    },
    createTree() {
      this.$refs.goodsTree.create();
    },
    create() {
      this.$refs.editDialog.openCreate(this.data);
    },
    delRows() {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择要删除的数据");
        return;
      }
      this.$confirm("确认删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = rows.map((item) => {
            return item.GoodsId;
          });
          this.$refs.list.delRange(ids);
        })
        .catch(() => {});
    },
  },
};
</script>